import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { catchError, map, of } from 'rxjs';
import { FilterOptions } from '../../../../../../shared/interfaces/filterOptions.interface';
import { ApiAdminService } from '../api/api-admin.service';
import { UserRole } from '@data/enums/user-role.enum';

@Injectable({
  providedIn: 'root'
})
export class AdminService {
  entity!: FormGroup
  formMethod = 'CREATE'
  roles: { label: string; value: string; }[] = []
  admin: any
  statuses = [
    { label: 'Activo', value: 'ACTIVE' },
    { label: 'Bloqueado', value: 'BLOCKED' }
  ]

  constructor(
    private fb: FormBuilder,
    private http: HttpClient,
    private apiAdminService: ApiAdminService
  ) {
    this.fetchRoles()
  }

  newEntity() {
    switch (this.formMethod) {
      case 'CREATE':
        // ADR-0014 (extendido a User): la contraseña ya NO se captura aquí. El backend
        // genera una temporal, la envía por correo y obliga a cambiarla en el primer ingreso.
        this.entity = this.fb.group({
          role: ['', [Validators.required]],
          names: ['', [Validators.required, Validators.pattern(/^[A-Za-z\s]+$/)]],
          lastNames: ['', [Validators.required, Validators.pattern(/^[A-Za-z\s]+$/)]],
          email: ['', [Validators.required, Validators.email]],
        })
        break;
      case 'EDIT':
        this.entity = this.fb.group({
          role: [this.admin.role._id, [Validators.required]],
          names: [this.admin.names, [Validators.required, Validators.pattern(/^[A-Za-z\s]+$/)]],
          lastNames: [this.admin.lastNames, [Validators.required, Validators.pattern(/^[A-Za-z\s]+$/)]],
          email: [this.admin.email, [Validators.required, Validators.email]],
          status: [this.admin.status, [Validators.required]],
          isCommitteeMember: [!!this.admin.isCommitteeMember]
        })

        //* Al dejar de ser Admin la bandera pierde sentido, así que se apaga sola. El backend
        //* impone la misma regla — esto solo evita que el formulario muestre algo que no se
        //* va a guardar.
        this.entity.get('role')?.valueChanges.subscribe(() => {
          if (!this.isAdminRoleSelected) this.entity.get('isCommitteeMember')?.setValue(false)
        })
        break;
    }
  }

  /**
   * Solo un Admin puede ser miembro del Comité: `GET /users/committee-members` filtra por ese rol
   * y el endpoint de voto lo vuelve a exigir (ADR-0013). Por eso el control cuelga del rol elegido
   * en el formulario, no del que el usuario tenga guardado.
   */
  get isAdminRoleSelected(): boolean {
    return this.getRoleName(this.entity?.get('role')?.value) === UserRole.ADMIN
  }

  getRoleName(id: string) {
    return this.roles.find(c => c.value === id)?.label
  }

  getStatusName(status: string) {
    return status === 'ACTIVE' ? 'Activo' : 'Bloqueado'
  }

  fetchRoles() {
    this.apiAdminService.getRoles().subscribe((roles) => {
      this.roles = roles
    })
  }
}
